import { render, staticRenderFns } from "./SportHeaderPeriod.vue?vue&type=template&id=2fc7c539&scoped=true"
import script from "./SportHeaderPeriod.vue?vue&type=script&lang=js"
export * from "./SportHeaderPeriod.vue?vue&type=script&lang=js"
import style0 from "./SportHeaderPeriod.vue?vue&type=style&index=0&id=2fc7c539&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc7c539",
  null
  
)

export default component.exports